import './ProgressBar.css'

function ProgressBar({ value, label, shortLabel }) {
  return (
    <div className="claimform-phead">
      <div className="claimform-phead-inner">
        <div className="claimform-phead-label">
          <span className="claimform-phead-label-full">{label}</span>
          {shortLabel && <span className="claimform-phead-label-short">{shortLabel}</span>}
        </div>
        <div className="claimform-pbar-wrap">
          <div className="claimform-pbar-track">
            <div className="claimform-pbar-fill" style={{ width: `${value}%` }}></div>
          </div>
          <div className="claimform-pbar-plane">✈️</div>
        </div>
      </div>
    </div>
  )
}

export default ProgressBar
